module.exports = __webpack_public_path__ + "static/media/LANDMARKS-ID-Logo.fd5f28ea.svg";